export default {
  methods: {

    decodeRepresentative(rep) {
      return {
        title: `${rep.decoded_civility ? rep.decoded_civility : ""} ${rep.first_name ? rep.first_name : ""} ${rep.last_name}`,
        quality: rep.decoded_representative_quality,
        ...rep
      }
    },

    /**
     * apply func to an Array of Representatives
     * @return {Object} object to spread in computed
     */
    decodeRepresentatives(first) {
      const isArrayName = _.isString(first),
        arr = (isArrayName) ? this[first] : first

      return _.chain(arr)
        .map(rep => this.decodeRepresentative(rep))
        .value()
    },

    decodeRepresentativesForSearch(first) {
        const isArrayName = _.isString(first),
            arr = (isArrayName) ? this[first] : first

        return _.chain(arr)
            .map(rep => this.decodeRepresentative(rep.person))
            .value()
    },
  },
}



// WEBPACK FOOTER //
// ./client/mixins/representatives.js